"use client";

import { c as _c } from "react/compiler-runtime";
import { EventEnum } from "@sprawdzonabron/shared";
import cn from "classnames";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FiChevronDown, FiChevronUp, FiMenu, FiPlus, FiX } from "react-icons/fi";
import { TestIdEnum } from "../../../../../tests/types";
import { useAnalyticsEvent } from "../../../../api/hooks/useAnalyticsEvent";
import { Button } from "../../../Button/Button";
import { HideableEmail } from "../../../HideableEmail/HideableEmail";
import { Modal } from "../../../Modal/Modal";
import { ThemeSwitcher } from "../../../ThemeSwitcher/ThemeSwitcher";
const AddShopContent = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>Jeżeli zauważyłeś(aś) brak sklepu, który powinien znajdować się w bazie, prosimy o zgłoszenie.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p>Napisz do nas na adres: <HideableEmail email="kontakt@sprawdzonabron.pl" /></p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="font-semibold text-slate-900 dark:text-white">Tytuł: <span className="font-normal">Zgłoszenie o dodanie sklepu</span></p>;
    t3 = <p className="font-semibold text-slate-900 dark:text-white">Treść:</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-2 text-sm text-slate-600 dark:text-slate-300">{t0}{t1}{t2}<div>{t3}<ul className="list-disc list-inside pl-2"><li>Nazwa sklepu</li><li>Adres www strony internetowej</li><li>Link do Google Maps</li><li>(Opcjonalnie) Jeżeli jesteś właścicielem. Zostaw do siebie kontakt - imię oraz email lub telefon.</li></ul></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
const AddSuggestionContent = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>Jeżeli masz sugestię, co moglibyśmy usprawnić w naszym serwisie, prosimy o zgłoszenie.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p>Napisz do nas na adres: <HideableEmail email="kontakt@sprawdzonabron.pl" /></p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="font-semibold text-slate-900 dark:text-white">Tytuł: <span className="font-normal">Sugestia</span></p>;
    t3 = <p className="font-semibold text-slate-900 dark:text-white">Treść:</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-2 text-sm text-slate-600 dark:text-slate-300">{t0}{t1}{t2}<div>{t3}<ul className="list-disc list-inside pl-2"><li>Czego dotyczy sugestia? (np. Brak wyszukiwania ofert w odległości X km od miasta)</li><li>Jak Twoim zdaniem powinno to działać? (np. Możliwość wybrania miasta oraz odległości w wyszukiwarce)</li><li>Dodatkowe informacje</li></ul></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
const ActionButtons = t0 => {
  const $ = _c(25);
  const {
    className
  } = t0;
  const [isAddShopModalOpen, setAddShopModalOpen] = useState(false);
  const [isAddSuggestionModalOpen, setAddSuggestionModalOpen] = useState(false);
  const postAddShopEvent = useAnalyticsEvent(EventEnum.AddShop);
  const postAddSuggestionEvent = useAnalyticsEvent(EventEnum.AddSuggestion);
  let t1;
  if ($[0] !== postAddShopEvent) {
    t1 = () => {
      postAddShopEvent("button");
      setAddShopModalOpen(true);
    };
    $[0] = postAddShopEvent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleAddShopClick = t1;
  let t2;
  if ($[2] !== postAddSuggestionEvent) {
    t2 = () => {
      postAddSuggestionEvent("button");
      setAddSuggestionModalOpen(true);
    };
    $[2] = postAddSuggestionEvent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleAddSuggestionClick = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FiPlus />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleAddShopClick) {
    t4 = <Button onClick={handleAddShopClick} icon={t3} data-testid={TestIdEnum.AddShopButton}>Dodaj sklep</Button>;
    $[5] = handleAddShopClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleAddSuggestionClick) {
    t5 = <Button onClick={handleAddSuggestionClick} data-testid={TestIdEnum.AddSuggestionButton}>Zgłoś sugestię</Button>;
    $[7] = handleAddSuggestionClick;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== className || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className={className}>{t4}{t5}</div>;
    $[9] = className;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setAddShopModalOpen(false);
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <AddShopContent />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isAddShopModalOpen) {
    t9 = <Modal isOpen={isAddShopModalOpen} onClose={t7} title="Dodaj sklep">{t8}</Modal>;
    $[15] = isAddShopModalOpen;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setAddSuggestionModalOpen(false);
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <AddSuggestionContent />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isAddSuggestionModalOpen) {
    t12 = <Modal isOpen={isAddSuggestionModalOpen} onClose={t10} title={"Zg\u0142o\u015B sugesti\u0119"}>{t11}</Modal>;
    $[19] = isAddSuggestionModalOpen;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t6 || $[23] !== t9) {
    t13 = <>{t6}{t9}{t12}</>;
    $[21] = t12;
    $[22] = t6;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
const getLinkClassName = (isActive: boolean) => {
  return cn("rounded-md px-3 py-2 text-base font-medium transition-colors w-full flex items-center justify-between", isActive ? "bg-brand-100 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300" : "bg-slate-50 text-slate-900 hover:bg-slate-100 hover:text-brand-600 dark:bg-slate-700/50 dark:text-white dark:hover:bg-slate-700 dark:hover:text-brand-400");
};
interface ExpandableMenuItemProps {
  label: string;
  items: {
    url: string;
    label: string;
    onClick: () => void;
  }[];
}
const ExpandableMenuItem = t0 => {
  const $ = _c(31);
  const {
    label,
    items
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== items || $[1] !== pathname) {
    t1 = () => {
      const isActive = items.some(item => pathname.startsWith(item.url));
      if (isActive) {
        setIsExpanded(true);
      }
    };
    t2 = [pathname, items];
    $[0] = items;
    $[1] = pathname;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== pathname) {
    t3 = href => {
      const isActive_0 = pathname === href;
      return cn("rounded-md px-3 py-2 text-sm font-medium transition-colors block", isActive_0 ? "bg-brand-100 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300" : "text-slate-600 hover:bg-slate-100 hover:text-brand-600 dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-brand-400");
    };
    $[4] = pathname;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const getReportLinkClassName = t3;
  let t4;
  let t5;
  if ($[6] !== isExpanded || $[7] !== items || $[8] !== pathname) {
    let t6;
    if ($[11] !== pathname) {
      t6 = item_0 => pathname.startsWith(item_0.url);
      $[11] = pathname;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    const isActive_1 = items.some(t6);
    if ($[13] !== isExpanded) {
      t4 = () => setIsExpanded(!isExpanded);
      $[13] = isExpanded;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t5 = getLinkClassName(isActive_1);
    $[6] = isExpanded;
    $[7] = items;
    $[8] = pathname;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[15] !== label) {
    t6 = <span>{label}</span>;
    $[15] = label;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isExpanded) {
    t7 = isExpanded ? <FiChevronUp /> : <FiChevronDown />;
    $[17] = isExpanded;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <button onClick={t4} className={t5}>{t6}{t7}</button>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== getReportLinkClassName || $[25] !== isExpanded || $[26] !== items) {
    t9 = isExpanded && <div className="mt-1 ml-2 flex flex-col space-y-1 border-l-2 border-slate-200 dark:border-slate-700 pl-2">{items.map(item_1 => <Link key={item_1.url} href={item_1.url} className={getReportLinkClassName(item_1.url)} onClick={item_1.onClick}>{item_1.label}</Link>)}</div>;
    $[24] = getReportLinkClassName;
    $[25] = isExpanded;
    $[26] = items;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t8 || $[29] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};
interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}
const Drawer = t0 => {
  const $ = _c(65);
  const {
    isOpen,
    onClose
  } = t0;
  const [isMounted, setIsMounted] = useState(false);
  const pathname = usePathname();
  const postMenuEvent = useAnalyticsEvent(EventEnum.MenuButton);
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = () => {
      setIsMounted(true);
      const handleEsc = event => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      if (isOpen) {
        window.addEventListener("keydown", handleEsc);
        document.body.style.overflow = "hidden";
      }
      return () => {
        window.removeEventListener("keydown", handleEsc);
        document.body.style.overflow = "unset";
      };
    };
    t2 = [isOpen, onClose];
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isOpen || !isMounted) {
    return null;
  }
  let t3;
  if ($[4] !== pathname) {
    t3 = href => {
      const isActive = pathname === href;
      return cn("text-sm transition-colors", isActive ? "text-brand-600 dark:text-brand-400 font-medium" : "text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white");
    };
    $[4] = pathname;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const getSubLinkClassName = t3;
  let t4;
  if ($[6] !== onClose || $[7] !== postMenuEvent) {
    t4 = info => () => {
      postMenuEvent(info);
      onClose();
    };
    $[6] = onClose;
    $[7] = postMenuEvent;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const closeWithEvent = t4;
  let t5;
  if ($[9] !== onClose) {
    t5 = <div className="fixed inset-0 bg-slate-900 bg-opacity-75 transition-opacity" onClick={onClose} />;
    $[9] = onClose;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2 className="text-lg font-semibold leading-6 text-slate-900 dark:text-white" id="drawer-title">Menu</h2>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="sr-only">Close panel</span>;
    t8 = <FiX className="h-6 w-6" aria-hidden="true" />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== onClose) {
    t9 = <div className="px-4 sm:px-6 flex items-center justify-between">{t6}<button type="button" className="rounded-md text-slate-400 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-brand-500" onClick={onClose}>{t7}{t8}</button></div>;
    $[14] = onClose;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h3 className="text-base font-semibold text-brand-900 dark:text-brand-100 mb-2">Checklista zakupowa</h3>;
    t11 = <p className="text-sm text-brand-700 dark:text-brand-300 mb-4">Sprawdź broń krok po kroku przed zakupem z naszą darmową checklistą.</p>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  let t12;
  if ($[18] !== closeWithEvent) {
    t12 = <div className="bg-brand-50 dark:bg-brand-900/20 p-4 rounded-lg">{t10}{t11}<Link onClick={closeWithEvent("cta-checklista")} href="/checklista-zakupowa" className="w-full justify-center relative inline-flex items-center justify-center overflow-hidden text-xs md:text-sm font-bold tracking-wide transition-all duration-300 rounded-lg group px-5 py-1.5 md:px-6 md:py-2 text-white uppercase bg-gradient-to-r from-brand-600 to-brand-500 shadow-md hover:shadow-glow">Otwórz checklistę</Link></div>;
    $[18] = closeWithEvent;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = pathname === "/";
  let t14;
  if ($[20] !== t13) {
    t14 = getLinkClassName(t13);
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== closeWithEvent) {
    t15 = closeWithEvent("home");
    $[22] = closeWithEvent;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14 || $[25] !== t15) {
    t16 = <Link href="/" className={t14} onClick={t15}>Strona główna</Link>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const t17 = pathname === "/faq";
  let t18;
  if ($[27] !== t17) {
    t18 = getLinkClassName(t17);
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== closeWithEvent) {
    t19 = closeWithEvent("faq");
    $[29] = closeWithEvent;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t18 || $[32] !== t19) {
    t20 = <Link href="/faq" className={t18} onClick={t19}>FAQ</Link>;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== closeWithEvent) {
    t21 = {
      url: "/raporty/badanie-rynku-strzelcow-jak-kupujemy-2026",
      label: "Badanie Rynku 2026",
      onClick: closeWithEvent("badanie-rynku-strzelcow-jak-kupujemy-2026")
    };
    $[34] = closeWithEvent;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== closeWithEvent) {
    t22 = {
      url: "/raporty/raport-cenowy-wybranych-modeli-broni-grudzien-2025",
      label: "Raport Cenowy 12.2025",
      onClick: closeWithEvent("raport-cenowy-wybranych-modeli-broni-grudzien-2025")
    };
    $[36] = closeWithEvent;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t21 || $[39] !== t22) {
    t23 = <ExpandableMenuItem label="Raporty" items={[t21, t22]} />;
    $[38] = t21;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t16 || $[42] !== t20 || $[43] !== t23) {
    t24 = <nav className="flex flex-col space-y-2">{t16}{t20}{t23}</nav>;
    $[41] = t16;
    $[42] = t20;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <ActionButtons className="flex flex-col md:hidden gap-2" />;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t12 || $[47] !== t24) {
    t26 = <div className="space-y-6">{t12}{t24}{t25}</div>;
    $[46] = t12;
    $[47] = t24;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== getSubLinkClassName) {
    t27 = getSubLinkClassName("/polityka-prywatnosci");
    $[49] = getSubLinkClassName;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== closeWithEvent) {
    t28 = closeWithEvent("privacy-policy");
    $[51] = closeWithEvent;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== t27 || $[54] !== t28) {
    t29 = <div className="border-t border-slate-200 dark:border-slate-700 pt-6 mt-6"><nav className="flex flex-col space-y-3"><Link href="/polityka-prywatnosci" className={t27} onClick={t28}>Polityka prywatności</Link></nav></div>;
    $[53] = t27;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t26 || $[57] !== t29) {
    t30 = <div className="relative mt-6 flex-1 px-4 sm:px-6 flex flex-col justify-between">{t26}{t29}</div>;
    $[56] = t26;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t30 || $[60] !== t9) {
    t31 = <div className="fixed inset-y-0 right-0 z-50 w-full max-w-xs bg-white dark:bg-slate-800 shadow-xl transition-transform transform duration-300 ease-in-out"><div className="flex h-full flex-col overflow-y-auto py-6 shadow-xl">{t9}{t30}</div></div>;
    $[59] = t30;
    $[60] = t9;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t31 || $[63] !== t5) {
    t32 = createPortal(<div className="relative z-50" aria-labelledby="drawer-title" role="dialog" aria-modal="true">{t5}{t31}</div>, document.body);
    $[62] = t31;
    $[63] = t5;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  return t32;
};
export const Menu = () => {
  const $ = _c(15);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const postMenuEvent = useAnalyticsEvent(EventEnum.MenuButton);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ThemeSwitcher />;
    t1 = <ActionButtons className="hidden md:flex gap-2" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== postMenuEvent) {
    t2 = () => {
      setDrawerOpen(true);
      postMenuEvent("menu-open");
    };
    $[2] = postMenuEvent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FiMenu className="w-6 h-6" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <button onClick={t2} className="p-2 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full transition-colors" aria-label="Menu">{t3}</button>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== postMenuEvent) {
    t5 = () => {
      setDrawerOpen(false);
      postMenuEvent("menu-close");
    };
    $[7] = postMenuEvent;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isDrawerOpen || $[10] !== t5) {
    t6 = <Drawer isOpen={isDrawerOpen} onClose={t5} />;
    $[9] = isDrawerOpen;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="flex items-center gap-4">{t0}{t1}{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};